interface SectionLabelProps {
  text: string;
  className?: string;
}

export function SectionLabel({ text, className = '' }: SectionLabelProps) {
  return (
    <p
      className={`text-[16px] font-medium text-primary mb-4 font-sans ${className}`}
    >
      {text}
    </p>
  );
}
